exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/tui-calendar/1.14.1/tui-calendar.css);", ""]);

// module
exports.push([module.id, ".tui-full-calendar-timegrid-hour{font-size:18px}.tui-full-calendar-timegrid-hourmarker-time{font-size:18px!important}.cols{display:flex;align-items:center;justify-content:space-between}.nav-planning button{width:100%;margin:0 4px}.tui-full-calendar-time-schedule-content-time,.tui-full-calendar-weekday-schedule-title{font-size:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16bf8a66","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/planning/Agenda.vue
// module id = 698
// module chunks = 0